import { render, staticRenderFns } from "./DepositForArgentinaTab.vue?vue&type=template&id=d436db6e&scoped=true"
import script from "./DepositForArgentinaTab.vue?vue&type=script&lang=js"
export * from "./DepositForArgentinaTab.vue?vue&type=script&lang=js"
import style0 from "./DepositForArgentinaTab.vue?vue&type=style&index=0&id=d436db6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d436db6e",
  null
  
)

export default component.exports